/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/recommendations/recommendationsQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useCallback } from 'react';
import Raven from 'raven-js';
import { useRecommendationsState } from './recommendationsStore.migrated';
import { usePostRankedRecommendationsContentEngagedFeedback } from 'academy-common-lib/features/recommendations/hooks/usePostRankedRecommendationsContentEngagedFeedback';

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/recommendations/recommendationsQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const usePostRecommendationsContentEngagedFeedback = () => {
  const {
    clearLastClickedRecommendationItem,
    lastClickedRecommendationItem
  } = useRecommendationsState();
  const {
    postRankedRecommendationsContentEngagedFeedback,
    postRankedRecommendationsContentEngagedFeedbackError,
    postRankedRecommendationsContentEngagedFeedbackLoading
  } = usePostRankedRecommendationsContentEngagedFeedback();
  const postRecommendationsContentEngagedFeedback = useCallback(({
    item,
    contentId
  }) => {
    if (!lastClickedRecommendationItem || lastClickedRecommendationItem.item.id !== item.id || lastClickedRecommendationItem.item.type !== item.type) return;
    return postRankedRecommendationsContentEngagedFeedback({
      correlationId: lastClickedRecommendationItem.correlationId,
      contentContainerType: item.type,
      resultId: item.id,
      engagedContentId: contentId
    }).catch(Raven.captureException.bind(Raven)).finally(() => {
      clearLastClickedRecommendationItem();
    });
  }, [clearLastClickedRecommendationItem, lastClickedRecommendationItem, postRankedRecommendationsContentEngagedFeedback]);
  return {
    postRecommendationsContentEngagedFeedback,
    postRecommendationsContentEngagedFeedbackError: postRankedRecommendationsContentEngagedFeedbackError,
    postRecommendationsContentEngagedFeedbackLoading: postRankedRecommendationsContentEngagedFeedbackLoading
  };
};